import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { UnicodeEntity } from '@mews/enums';
import { LocalizedDateFromUtc, LocalizedDayNameFromUtc, SpacedDash } from '@mews-commander/ui';
import { Container } from '@optimus-web/core';

interface TimeUnitCountsLabelProps {
    startUtc: string | undefined;
    endUtc: string | undefined;
}

const TimeUnitCountLabel = ({ startUtc, endUtc }: TimeUnitCountsLabelProps) => {
    if (!startUtc || !endUtc) {
        return null;
    }

    return (
        <>
            <Container display="inline-block">
                <LocalizedDateFromUtc utcString={startUtc} />
                {SpacedDash}
                <LocalizedDateFromUtc utcString={endUtc} />
            </Container>
            {UnicodeEntity.NoBreakSpace}
            {UnicodeEntity.LeftParenthesis}
            <LocalizedDayNameFromUtc utcString={startUtc} />
            {UnicodeEntity.NoBreakSpace}
            <LocalizedText lowerCase textKey={TextKey.ToDate} />
            {UnicodeEntity.NoBreakSpace}
            <LocalizedDayNameFromUtc utcString={endUtc} />
            {UnicodeEntity.RightParenthesis}
        </>
    );
};

export default TimeUnitCountLabel;
